import {
  ShipmentDownloadResponse,
  ShipmentUIResponse,
} from "../../models/ApiResponse";
import { ShipmentResponse } from "../../models/responseModels/shipmentResponse";
import { axiosRequests } from "../axiosRequest";

export const ShipmentAgent = {
  getShipmentList: () =>
    axiosRequests.get<ShipmentUIResponse>("/shipment/GetShipmentList"),
  shipmentCsvDownload: (shipmentData: ShipmentResponse[]) =>
    axiosRequests.post<ShipmentDownloadResponse>(
      "/shipment/downloadCsv",
      shipmentData
    ),
  shipmentXlsxDownload: (shipmentData: ShipmentResponse[]) =>
    axiosRequests.postXlsx<Blob>("/shipment/downloadXlsx", shipmentData),
};
